module.exports = require("webworkify-webpack");